export default __webpack_public_path__ + "static/Audun-7668bee2ec5d24d23233244480030b32.jpg";